import React, { Component } from "react";
import { withRouter } from "react-router-dom";

class BackButton extends Component {
  render() {
    return <div onClick={this.props.history.goBack}>返回</div>;
  }
}
export default withRouter(BackButton);
